import { layoutPerPartners } from '../constants';
import { PartnerLayout, PartnerOrganization } from '../types/partnerType.type';

/**
 *  There is two way to mock the partner name to retrieve the PartnerLayout:
 *  const organizationName = useOrganizationName();
 *  const partnerType = getPartnerLayout(organizationName);
 *  or
 *  const partnerType = getPartnerLayout(PartnerOrganization.MUSC);
 */

const getPartnerLayout = (organization: string): PartnerLayout => {
  return layoutPerPartners[organization] || PartnerLayout.DEFAULT;
};

export const buildSwitchPartnerLayouts = (): { [k: string]: PartnerLayout } => {
  const obj: { [k: string]: PartnerLayout } = {};
  Object.values(PartnerOrganization).forEach((org) => {
    obj[org] = getPartnerLayout(org);
  });

  return obj;
};

export const getParticipantRecruitmentLayouts = (): Array<{ id: string; layout: PartnerLayout; value: string }> => {
  return Object.keys(layoutPerPartners).map((org: string) => ({
    id: org,
    layout: getPartnerLayout(org),
    value: org,
  }));
};

export default getPartnerLayout;
